import { filter, Subject } from 'rxjs';

import { getCookie, getData, metricsLog, setData } from './utils';
import { v4 as uuidv4 } from 'uuid';
import { PixelsVideoEvent } from '../../constants/Video';

export const videoSession = (sub: Subject<[string, any]>, pixelsUUIDKey: string, typeOfIntegration: string) => {
  const videoVisit$ = sub.pipe(
    filter(([type]) => [PixelsVideoEvent.FIRST_FRAME, PixelsVideoEvent.AD_STARTED].includes(type as PixelsVideoEvent)),
  );

  videoVisit$.subscribe(() => {
    const uuid = uuidv4();
    const pixUUID = getCookie(pixelsUUIDKey);
    const storageKey = `${pixUUID}-${typeOfIntegration}`;
    const payload = getData(storageKey);

    metricsLog(`Video session id: ${uuid}`);

    setData(storageKey, {
      ...payload,
      video_session: {
        value: uuid,
      },
    });
  });
};
